// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1P9Ve","dragIcon":"Choice_dragIcon__3rvw3","left":"Choice_left__3NKVF","input":"Choice_input__1QyQT"};